<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
                
                    <h3 class="mb-0">
                        {{ $tc('message.allergies', 2) }}
                    </h3>
                </div>
            </div>

            <div class="">
                <div class="card-title">
                    <router-link :to="{ name: 'add-allergy' }" v-if="can">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>

                <template v-if="rows">
                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mAllergies"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <!--<b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group label-cols-sm="3" :label="$t('message.filter')" class="mb-0">
                                    <b-form-select v-model="sortDesc">
                                        <option :value="true">{{ $t('message.latest') }}</option>

                                        <option :value="false">{{ $t('message.oldest') }}</option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                    </b-container>

                    <b-table
                            id="allergies-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mAllergies"
                    >
                        <!-- A virtual composite column for actions -->
                        <template slot="action" slot-scope="data">
                            <div class="row" v-if=" hasMedecinControleRole || hasAdminRole || hasAssistante">
                                <div class="col-sm-6">
                                    <b-link :to="{ name: 'edit-allergy', params: { allergy: data.item.slug } }">
                                        <i class="fas fa-edit fa-2x edit-icon"></i>
                                    </b-link>
                                </div>

                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.allergies', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }} {{ data.item.title }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deleteAllergy(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            class="justify-content-center"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="allergies-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "Allergies",

        computed: {
            ...mapGetters(["allergies",'hasAdminRole',
                'hasMedecinControleRole',
                'hasAssistante',
                'hasPraticienRole',
            ]),
            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },

            mAllergies: function() {
                let aArray = [];

                _.forEach(this.allergies, function(allergy) {
                    let a = {};
                    a.description = allergy.description.length > 20 ? allergy.description.substr(0, 20) + '...' : allergy.description;
                    a.date = moment(allergy.created_at).format('YYYY/MM/DD HH:mm');
                    a.id = allergy.id;
                    a.slug = allergy.slug;
                    a.isAuthor = allergy.isAuthor;

                    aArray.push(a);
                });

                return aArray;
            },

            rows: function() {
                return this.mAllergies.length;
            }
        },

        data() {
            return {
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'description',
                        label: this.$i18n.t('message.description'),
                    },
                    {
                        key: 'date',
                        label: this.$i18n.t('message.createdAt'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getAllergies() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getAllergies', { args : args });
            },

            formattedDisplay (result) {
                return result.title;
            },

            rowSelected(items) {
                this.$router.push({ name: 'allergy', params: { allergy: items[0].slug } });
            },

            itemSelected(item) {
                this.$router.push({ name: 'allergy', params: { allergy: item.selectedObject.slug } });
            },

            deleteAllergy(allergy) {
                let self = this;

                let args = {
                    allergy: allergy
                };

                let successMessage = this.$i18n.t('message.allergyDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteAllergy', { args, index: allergy, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + allergy);
                    });
            }
        },

        mounted() {
            // Fetch allergy list
            this.getAllergies();
        }
    }
</script>

<style scoped>

</style>